import i18n from "i18n";

const tableHeaders = {
  name: {
    name: "name",
    title: i18n.t("name").toUpperCase(),
    active: false,
    direction: false,
    value: "name",
  },
  description: {
    name: "description",
    title: i18n.t("description").toUpperCase(),
    active: false,
    direction: false,
    value: "description",
  },
  date: {
    name: "date",
    title: i18n.t("creation.date").toUpperCase(),
    active: false,
    direction: false,
    value: "created_at",
  },
  type: {
    name: "type",
    title: i18n.t("type").toUpperCase(),
    active: false,
    direction: false,
    value: "type",
  },
  dimensions: {
    name: "dimensions",
    title: i18n.t("dimensions").toUpperCase(),
    active: false,
    direction: false,
    value: "height",
  },
  memories: {
    name: "memories",
    title: i18n.t("memories").toUpperCase(),
    active: false,
    direction: false,
    value: "mem_epc",
  },
};

export default tableHeaders;
